import React from "react";
import FilePreview from "../../../../../shared/file-preview/file-preview";
import { Button } from "antd";
import { SelectedFileInfo } from "./verification-packet-document-picker";

interface FilePickerDocumentListProps {
  caseType: string;
  caseData: {
    id: string;
    files: FileData[];
  };
  handleFileSelection: (fileInfo: SelectedFileInfo) => void;
}

interface FileData {
  id: string;
  name: string;
  type: string;
  url: string;
}

export const FilePickerDocumentList: React.FC<FilePickerDocumentListProps> = ({
  caseData,
  handleFileSelection,
}) => {
  const onFileSelect = (fileInfo: SelectedFileInfo) => {
    handleFileSelection(fileInfo);
  };
  
  const memoizedFileList = React.useMemo(
    () =>
      caseData?.files.map((data: FileData) => (
        <div
          key={data.name}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <FilePreview
            fileUrl={data.url}
            fileName={data.name.split("/").pop() ?? ""}
            fileType={data.type ?? ""}
          />
          <Button
            type="primary"
            style={{
              alignContent: "center",
              marginTop: "25px",
            }}
            onClick={() =>
              onFileSelect({
                name: data.name,
                url: data.url,
                caseType: "credential",
                caseId: caseData.id,
                type: data.type
              } as SelectedFileInfo)
            }
          >
            Select
          </Button>
        </div>
      )),
    [caseData?.files]
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "16px",
        margin: "0 auto",
        padding: "10px",
      }}
    >
      {memoizedFileList}
    </div>
  );
};